import { render, staticRenderFns } from "./Singpass.vue?vue&type=template&id=5df75a97&scoped=true&"
import script from "./Singpass.vue?vue&type=script&lang=js&"
export * from "./Singpass.vue?vue&type=script&lang=js&"
import style0 from "./Singpass.vue?vue&type=style&index=0&id=5df75a97&prod&lang=scss&scoped=true&"
import style1 from "./Singpass.vue?vue&type=style&index=1&id=5df75a97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df75a97",
  null
  
)

export default component.exports